import { AuthBody } from 'models/AuthBody';
import cookieService, { COOKIE_KEYS } from 'services/cookieService';

export default {
  get token(): string {
    return cookieService.getItem<string>(COOKIE_KEYS.DR_TOKEN);
  },

  set token(token: string) {
    cookieService.setItem(COOKIE_KEYS.DR_TOKEN, token);
  },

  saveAuthBody({ token }: Omit<AuthBody, 'user' | 'refreshToken'>) {
    cookieService.setItem(COOKIE_KEYS.DR_TOKEN, token);
  },

  removeAuthBody() {
    cookieService.removeItem(COOKIE_KEYS.DR_TOKEN);
  },
};
